import { ArrowRight, ArrowLeft, Star, X } from "lucide-react";
import { img } from "../../lib/api";
import { Uploader } from "./ui";

export const ImagesEditor = ({ images, onChange }) => {
  const move = (i, d) => {
    const j = i + d;
    if (j < 0 || j >= images.length) return;
    const a = [...images];
    [a[i], a[j]] = [a[j], a[i]];
    onChange(a);
  };
  const makeMain = (i) => onChange([images[i], ...images.filter((_, k) => k !== i)]);
  return (
    <div>
      <div className="grid grid-cols-3 gap-3 sm:grid-cols-5">
        {images.map((src, i) => (
          <div key={src + i} data-testid={`product-image-${i}`} className={`group relative aspect-[3/4] overflow-hidden rounded border ${i === 0 ? "border-gold ring-2 ring-gold/40" : "border-gray-200"}`}>
            <img src={img(src)} alt="" className="h-full w-full object-cover" />
            {i === 0 && <span className="absolute right-1 top-1 rounded bg-ink px-1.5 py-0.5 text-[10px] text-white">الرئيسية</span>}
            <div className="absolute inset-x-0 bottom-0 flex justify-between bg-white/90 p-1">
              <button type="button" onClick={() => move(i, -1)} className="p-1 hover:text-gold-deep" title="تقديم"><ArrowRight size={14} /></button>
              <button type="button" data-testid={`make-main-image-${i}`} onClick={() => makeMain(i)} className="p-1 hover:text-gold-deep" title="تعيين كصورة رئيسية"><Star size={14} /></button>
              <button type="button" onClick={() => move(i, 1)} className="p-1 hover:text-gold-deep" title="تأخير"><ArrowLeft size={14} /></button>
              <button type="button" data-testid={`remove-image-${i}`} onClick={() => onChange(images.filter((_, k) => k !== i))} className="p-1 text-red-600" title="حذف"><X size={14} /></button>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-3"><Uploader onUploaded={(urls) => onChange([...images, ...urls])} /></div>
      <p className="mt-2 text-xs text-gray-500">الصورة الأولى هي الصورة الرئيسية. استخدمي الأسهم لإعادة الترتيب.</p>
    </div>
  );
};
